import { getLocale } from "@utils/configuration/aem";
import { addressMapper } from "./mappers/address.mapper";
import { storeMapper } from "./mappers/store.mapper";

export const fetchAddressSearchItems = (
    localitiesService: woosmap.map.LocalitiesService,
    inputValue: string,
    limit?: number
) => localitiesService
    .autocomplete({
        input: inputValue.toString(),
        components: {
            country: ["be", "nl", "lu"],
        },
        types: ["locality", "postal_code"],
        language: getLocale(true),
    })
    .then(({ localities }) =>
        localities
            .filter(l => !!l.matched_substrings)
            .slice(0, limit)
            .map(addressMapper),
    );

export const fetchStoreSearchItems = (
    storesService: woosmap.map.StoresService,
    inputValue: string,
    limit?: number
) => storesService
    .autocomplete({
        language: getLocale(true),
        limit: limit,
        query: `localized:"${inputValue}" AND user.locale:="${getLocale()}"`,
    })
    .then(({ predictions }) =>
        predictions
            .filter(
                prediction => !!prediction.matched_substrings,
            )
            .map(storeMapper),
    );
